import PureTable from './PureTable';

export default PureTable;
